import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import '@capacitor-community/camera-preview';
import { TCameraModel } from './model/camera.types';
import { CAMERA_MODEL } from './model/camera.model';
import { CameraService } from './camera.service';
import { BucketStorageService } from '../bucket-storage.service';
import { ModalController } from '@ionic/angular';
import { TBucketInfo } from '../bucket-storage.types';

@Component({
  selector: 'monorepo-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss'],
})
export class CameraComponent implements OnInit {
  @ViewChild('cameraElm') cameraElm!: ElementRef<HTMLDivElement>;
  @Input() CAMERA_MODEL!: TCameraModel;

  constructor(
    private cameraService: CameraService,
    private bucketStorage: BucketStorageService,
    private modelController: ModalController,
  ) {}

  ionViewDidEnter() {
    const boundedRect = this.cameraElm.nativeElement.getBoundingClientRect();
    this.openCamera(boundedRect);
  }
  ngOnInit(): void {
    this.#updateFiles();
  }

  async openCamera(boundedRect: DOMRect) {
    this.CAMERA_MODEL = CAMERA_MODEL.updateState('INTIALIZE', this.CAMERA_MODEL);
    this.cameraService.start(boundedRect).then(() => {
      this.CAMERA_MODEL = CAMERA_MODEL.updateState('LOADED', this.CAMERA_MODEL);
    });
  }

  async stopCamera() {
    await this.toggleCamera();
  }

  async removeFile(file: TBucketInfo['files'][number]) {
    await this.bucketStorage.removeFileByUri(file.uri);
    this.#updateFiles();
  }

  async previewFile(fileIndex: number) {
    this.CAMERA_MODEL = CAMERA_MODEL.updateState('PREVIEW', this.CAMERA_MODEL);
    this.CAMERA_MODEL = CAMERA_MODEL.updatePreviewIndex(fileIndex, this.CAMERA_MODEL);
  }

  async toggleCamera() {
    this.CAMERA_MODEL = CAMERA_MODEL.updateState('PREVIEW', this.CAMERA_MODEL);
    this.cameraService
      .stop()
      .then(() => {
        console.log('Stopping camera');
      })
      .catch((err) => {
        console.log('Error', err);
        this.ionViewDidEnter();
      });
  }

  openGallery() {
    if (this.CAMERA_MODEL.state === 'LOADED') {
      this.cameraService.stop();
    }
    this.CAMERA_MODEL = CAMERA_MODEL.updateState('GALLERY', this.CAMERA_MODEL);
  }

  async captureImage() {
    if (this.CAMERA_MODEL.bucketInfo.hasLimitReached) {
      console.log('[Alert] Reached limit');
      this.toggleCamera();
      return false;
    }

    this.CAMERA_MODEL = CAMERA_MODEL.updateState('TAKE_PHOTO', this.CAMERA_MODEL);
    const uri = await this.cameraService.takePhoto();
    const liftedFileInfo = await this.bucketStorage.getFileInfoByUri(uri);
    this.bucketStorage
      .saveFile(this.CAMERA_MODEL.bucketInfo, liftedFileInfo)
      .then(async () => {
        await this.#updateFiles();
      })
      .catch((err) => {
        console.log('[ERROR] In saving in bucket', err);
      });
    this.stopCamera();
    return true;
  }

  async #updateFiles() {
    const filesMetaData = await this.bucketStorage.getAllFiles(this.CAMERA_MODEL.bucketInfo);
    this.CAMERA_MODEL = CAMERA_MODEL.updateBucketFiles(filesMetaData, this.CAMERA_MODEL);
  }

  async done() {
    if (this.CAMERA_MODEL.state === 'LOADED') {
      this.toggleCamera();
    }
    this.modelController.dismiss(this.CAMERA_MODEL.bucketInfo);
  }

  #clearDirectory() {
    this.bucketStorage.remove(this.CAMERA_MODEL.bucketInfo).then((hasBeenRemoved) => {
      console.log('[Clear Directory]', hasBeenRemoved);
      this.#updateFiles();
    });
  }
}
